<script>
  import { createEventDispatcher } from 'svelte';

  import NotificationRow from '@app-components/NotificationRow.svelte';
  import VisibilityGuard from '@components/VisibilityGuard.svelte';

  export let notifications;
  export let notificationClicked;
  export let group;
  export let user;
  export let mobile;

  const dispatch = createEventDispatcher();

  let dispatchNotificationSeen = function (el, n) {
    dispatch('notification-seen', n);
  };
</script>

<style style="text/scss" lang="scss">
  @import '../vendor/design-system.scss';

  .notification-group {
    display: flex;
    flex-direction: column;
    padding-top: 10px;
    .notification-time-group {
      padding-left: 24px;
      padding-right: 24px;
      align-self: flex-start;
      height: 16px;
      font-style: normal;
      font-weight: 700;
      font-size: 12px;
      line-height: 16px;
      text-align: center;
      color: #7f7f7f;
      flex: none;
      order: 0;
      flex-grow: 0;
      margin-bottom: 10px;
    }
  }
</style>

<div class="notification-group">
  <div class="notification-time-group">{group}</div>
  {#each notifications as n}
    <NotificationRow notificationClicked={notificationClicked} notification={n} user={user} mobile={mobile} />
    <VisibilityGuard let:hasBeenVisible>
      {#if hasBeenVisible}
        <div style="display: none" use:dispatchNotificationSeen={n} />
      {/if}
    </VisibilityGuard>
  {/each}
</div>
